// import VxmAnalysis from './vxm-analysis';
import NetworkFiveStarSurveyReport from './network-five-star-survey';
import ChainEndDeclineRatio from './chain-end-decline-ratio';
import NkrDonorReferralConversionRate from './nkr-donor-referral-conversion-rate';
import ChainEndOffers from './chain-end-offers';
import MissedMatchOffers from './missed-match-offers';
import CenterCLCScoresReport from './center-clc-scores';
import CenterCLCTargetedPairsReport from './center-clc-targeted-pairs';
import CenterCLCGuide from './center-clc-guide';
import CenterClcScoreDetails from './center-clc-scores-details';
import CompareConversion from './comparison-conversion';
import CompareVolume from './comparison-volume';
import DashboardSummary from './dash-board/summary'
import DashboardVolume from './dash-board/volume'
import CprScoresReport from './cpr-scores';
import AdminReportsNav from './admin-nav';
import PatientDonors from './dash-board/patient-donors';
import DashPWLLabBilling from './dash-board/pwl/lab-billing'
import DashPWLJugBilling from './dash-board/pwl/jug-billing'
import Contacts from './dash-board/contacts'
import AllCenters from './all-centers';
import CenterSpecifc from './all-centers/center-specific';
import AdminRelativePerformance from './relative-performance';
import Compliance from './compliance';
import TransplantedPatients from './performance/transplanted-patients';
import PreSelectHistoryByCenterReport from './performance/pre-select-history-by-center';

interface IProps {
    tabKey: string,
    subTabKey: string,
    id: string
}

const AdminReports = (props: IProps) => {
    return (
        <div style={{ padding: '0px 10px' }}>
            <AdminReportsNav
                tabKey={props.tabKey}
                subTabKey={props.subTabKey}
                id={props.id}
            />

            {props.subTabKey == 'CONTACTS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <Contacts centerId={0} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'SUMMARY' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <DashboardSummary centerId={null} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'VOLUME' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <DashboardVolume centerId={null} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'NETWORK-FIVE-STAR-SURVEYS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <NetworkFiveStarSurveyReport centerId={null} isAdmin={true} />
                </div>
            )}

            {/* {props.subTabKey == 'VXM-ANALYSIS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <VxmAnalysis isCenterLogin={false} />
                </div>
            )} */}

            {props.subTabKey == 'COMPLIANCE' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <Compliance centerId={0} isCenterLogin={false} />
                </div>
            )}

            {props.subTabKey == 'DIRECTORY' && (
                <div style={{ backgroundColor: '#FFF' }}>
                    <AllCenters centerId={0} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'CENTER-SPECIFIC' && (
                <div style={{ backgroundColor: '#FFF' }}>
                    <CenterSpecifc centerId={parseInt(props.id)} />
                </div>
            )}

            {props.subTabKey == 'CLC-DETAILS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <CenterCLCScoresReport centerId={0} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'CLC-TARGETED-PAIRS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <CenterCLCTargetedPairsReport />
                </div>
            )}

            {props.subTabKey == 'CLC-SCORING-GUIDE' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <CenterCLCGuide />
                </div>
            )}

            {props.subTabKey == 'CLC-CENTER-DETAILS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <CenterClcScoreDetails centerId={parseInt(props.id)} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'CHAIN-END-DECLINE-RATIO' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <ChainEndDeclineRatio isCenterLogin={false} />
                </div>
            )}

            {props.subTabKey == 'NKR-DONOR-REFERRAL-CONVERSION-RATE' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <NkrDonorReferralConversionRate isCenterLogin={false} />
                </div>
            )}

            {props.subTabKey == 'CHAIN-END-OFFERS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <ChainEndOffers isCenterLogin={false} />
                </div>
            )}

            {props.subTabKey == 'MISSED-MATCH-OFFERS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <MissedMatchOffers centerId={0} isCenterLogin={false} />
                </div>
            )}

            {props.subTabKey == 'COMPARE-CONVERSION' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <CompareConversion centerId={0} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'COMPARE-VOLUME' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <CompareVolume centerId={0} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'PATIENT-DONORS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <PatientDonors centerId={0} />
                </div>
            )}

            {props.subTabKey == 'PWL-LABBILLING' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <DashPWLLabBilling centerId={0} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'PWL-JUGBILLING' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <DashPWLJugBilling centerId={0} isAdmin={true} />
                </div>
            )}

            {props.subTabKey == 'CPR' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <CprScoresReport allCenters={true} />
                </div>
            )}

            {props.subTabKey == 'RELATIVE-PERFORMANCE' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <AdminRelativePerformance />
                </div>
            )}

            {props.subTabKey == 'TRANSPLANTED-PATIENTS' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <TransplantedPatients centerId={0} isCenterLogin={false} />
                </div>
            )}

            {props.subTabKey == 'PRESELECT-HISTORY' && (
                <div style={{ padding: 10, backgroundColor: '#FFF' }}>
                    <PreSelectHistoryByCenterReport centerId={0} isAdmin={true} />
                </div>
            )}
        </div>
    );
}

export default AdminReports;